exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Playfair+Display&display=swap);", ""]);

// module
exports.push([module.id, "\n", ""]);

// exports
